module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-06-f4989c08613c5718725307859b727f49.png";